import { render, staticRenderFns } from "./confirmed-card.vue?vue&type=template&id=787aa2f0&scoped=true&lang=pug"
import script from "./confirmed-card.vue?vue&type=script&lang=ts"
export * from "./confirmed-card.vue?vue&type=script&lang=ts"
import style0 from "./confirmed-card.vue?vue&type=style&index=0&id=787aa2f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787aa2f0",
  null
  
)

export default component.exports